<template>
  <!-- banner上的标题 -->
  <div class="banner-title" :class="{ background: isBackground }">
    <div class="banner-menu">
      <div class="banner-image">
        <img src="../../../../assets/LOGO.png" alt="" />
      </div>
      <div class="banner-all">
        <div class="banner-word" :class="{ color: isColor }">
          <router-link
            v-for="(item, index) in links"
            :key="index"
            :to="item.path"
            class="word-item" exact
            >{{ item.title }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuMain from "./components/menu-main.vue";
export default {
  components: {
    menuMain
  },
  data() {
    return {
      isBackground: false,
      activeIndex:0,
      isColor: false,
      isShow: false,
      links: [
         {
          title: "首页",
          path: "/"
        },
        {
          title: "公司简介",
          path: "/about"
        },
        {
          title: "产品服务",
          path: "/serves"
        },
        {
          title: "加入我们",
          path: "/recruit"
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //屏幕划过bannrr图时，顶部菜单栏背景色为白色，字体颜色为黑色
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 520) {
        this.isBackground = true;
        this.isColor = true;
      } else {
        this.isBackground = false;
        this.isColor = false;
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import "./menu-list.less";
</style>



// WEBPACK FOOTER //
// src/views/home/components/menu-list/menu-list.vue